import { Chat, Prompt, ReducerAction, ReducerHandler } from '../../Types';
import { StoreChat } from '../../Types/StoreTypes';
import {
    SET_CHAT,
    SET_IS_SENDIING,
    SET_IS_NEW_CHAT,
    SET_CHAT_LOADED,
    SET_MESSAGES_LOADED,
    SET_PROMPTS,
    SET_WEBSOCKET_ERROR,
    SET_IS_STOPABLE,
    SET_CHAT_DLP_ACTIVE,
    SET_UPDATE_CHAT,
    SET_CHAT_MESSAGES,
    SET_CHAT_CONTAINER_STYLES,
    SET_CHAT_DLP,
    UPDATE_MESSAGE,
    ADD_MESSAGE,
} from '../Actions/chatActions';

const initialState = {
    chat: {} as Chat,
    chatMessages: {},
    isSending: false,
    isNewChat: false,
    chatLoaded: false,
    messagesLoaded: false,
    prompts: [] as Prompt[],
    websocketError: false,
    isStopable: false,
    updateChat: false,
    chatContainerStyles:
        parseInt(localStorage.getItem('chatContainerWidth') ?? '0') >= 450
            ? { maxWidth: parseInt(localStorage.getItem('chatContainerWidth') || '0') + 'px' }
            : {},
} as StoreChat;

const chatReducerMap: Record<string, ReducerHandler<StoreChat>> = {
    [SET_CHAT]: (state, action) => ({ ...state, chat: { ...state.chat, ...action.payload } }),
    [SET_IS_SENDIING]: (state, action) => ({ ...state, isSending: action.payload }),
    [SET_IS_NEW_CHAT]: (state, action) => ({ ...state, isNewChat: action.payload }),
    [SET_CHAT_LOADED]: (state, action) => ({ ...state, chatLoaded: action.payload }),
    [SET_MESSAGES_LOADED]: (state, action) => ({ ...state, messagesLoaded: action.payload }),
    [SET_PROMPTS]: (state, action) => ({ ...state, prompts: action.payload }),
    [SET_WEBSOCKET_ERROR]: (state, action) => ({ ...state, websocketError: action.payload }),
    [SET_IS_STOPABLE]: (state, action) => ({ ...state, isStopable: action.payload }),
    [SET_CHAT_DLP_ACTIVE]: (state, action) => ({ ...state, chat: { ...state.chat, dlp_active: action.payload } }),
    [SET_UPDATE_CHAT]: (state, action) => ({ ...state, updateChat: action.payload }),
    [SET_CHAT_MESSAGES]: (state, action) => ({ ...state, chatMessages: action.payload }),
    [SET_CHAT_CONTAINER_STYLES]: (state, action) => ({ ...state, chatContainerStyles: action.payload }),
    [SET_CHAT_DLP]: (state, action) => ({ ...state, chat: { ...state.chat, dlp: action.payload } }),
    [UPDATE_MESSAGE]: (state, action) => {
        const chatMessages = { ...state.chatMessages };
        chatMessages[action.payload.identifier] = {
            ...chatMessages[action.payload.identifier],
            ...action.payload,
        };
        return { ...state, chatMessages };
    },
    [ADD_MESSAGE]: (state, action) => {
        const chatMessages = { ...state.chatMessages };
        chatMessages[action.payload.identifier] = action.payload;
        return { ...state, chatMessages };
    },
};

function chatReducer(state = initialState, action: ReducerAction): StoreChat {
    const handler = chatReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default chatReducer;
